export class Plano {
    id: number;
    nome: string;
    segmentoId: number | null;
    segmentoNome?: string;
    valorBase: number;
    taxaAdesao: number;
    situacao: boolean;
    funcionalidadeIds: number[];
    wowveId?: number | null;

    constructor(
        id: number,
        nome: string,
        segmentoId: number | null,
        valorBase: number,
        taxaAdesao: number,
        situacao: boolean,
        funcionalidadeIds: number[] = [],
        wowveId?: number | null,
    ) {
        this.id = id;
        this.nome = nome;
        this.segmentoId = segmentoId;
        this.valorBase = valorBase;
        this.taxaAdesao = taxaAdesao;
        this.situacao = situacao;
        this.funcionalidadeIds = funcionalidadeIds;
        this.wowveId = wowveId;
    }
}
